import AbstractBinaryOperatorFormulaNode from "./AbstractBinaryOperatorFormulaNode.js";

/**
 * `divisionFormulaNode` is a concrete implementation
 * of `abstractFormulaNode` representing a division node.
 */
export default class DivisionFormulaNode extends AbstractBinaryOperatorFormulaNode {
	accept(visitor, additionalInformation) {
		return visitor.visitDivisionNode(this, additionalInformation);
	}

	getLabel() {
		return "/";
	}

	static getType() {
		return "DivisionNode";
	}

	static precedence() {
		return this.multiplicativeNodesPrecedence();
	}

	static build(builder, additionalInformation) {
		return builder.buildBinaryOperationNode(this, additionalInformation);
	}
}
